export const formatNumber = (number, digits = 3) => {
    if (number) {
        return Number(number.toFixed(digits)).toString();
    }

    return '0';
};

export const formatNumberWithComma = (value, decimals = 1) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return '0';

    const formatted = num.toFixed(decimals);
    const [wholePart, decimalPart] = formatted.split('.');

    if (decimalPart?.split('').every(digit => digit === '0')) {
        return wholePart;
    }

    return formatted.replace('.', ',');
};

export const formatPercent = (number, digits = 3) => {
    return `${formatNumber(number * 100, digits)}%`;
};

export const formatWeight = weightInGrams => {
    if (!weightInGrams || weightInGrams <= 0) {
        return '0 g';
    }

    if (weightInGrams < 1000) {
        return `${weightInGrams.toFixed(0)} g`;
    } else {
        const weightInKg = weightInGrams / 1000;
        return `${weightInKg.toFixed(1).replace('.', ',')} kg`;
    }
};
